import { createSelector } from '@ngrx/store';

import { getPaymentState } from './main.selectors';

export const getIsPaymentValid = createSelector(getPaymentState, (state) => state.valid);
